<template>
    <v-container fluid>
        <v-row>
            <v-col class="text-right">
                <ToggleFilterBtn v-if="hasFilters" />
            </v-col>
        </v-row>
        <v-data-table
            :loading="loading"
            :headers="headers"
            :items="data"
            :items-per-page="-1"
            hide-default-footer
        >
            <template v-slot:[`item.last_activation`]="{ item }">
                <span v-if="item.last_activation">
                    {{ $d(Date.parse(item.last_activation), 'datetime') }}
                </span>
                <span v-else>
                    -
                </span>
            </template>
            <template v-slot:[`item.mmr`]="{ item }">
                {{ $n(item.mmr, 'currency') }}
            </template>
            <template v-slot:[`item.category`]="{ item }">
                {{ item.category || '-' }}
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import axios from '@/plugins/axios'
import ToggleFilterBtn from '@/shared/components/filters/ToggleFilterBtn'

export default {
    components: {
        ToggleFilterBtn,
    },

    data: () => ({
        loading: true,
        data: [],
        hasFilters: false,
    }),

    computed: {
        filterKey() {
            return 'resellersReport'
        },

        headers() {
            return [
                {
                    text: 'Nome',
                    value: 'reseller',
                },
                {
                    text: 'Última Ativação',
                    value: 'last_activation',
                },
                {
                    text: 'Clientes',
                    value: 'customers',
                },
                {
                    text: 'MMR',
                    value: 'mmr',
                },
                {
                    text: 'Categoria',
                    value: 'category',
                },
            ]
        },

        filters() {
            return this.$store.getters['filters/current'][this.filterKey]
        },

        filtersQuery() {
            return this.$store.getters['filters/queryString'](this.filterKey)
        },
    },

    watch: {
        filters() {
            this.fetchData()
        },
    },

    methods: {
        async fetchData() {
            this.loading = true
            let url = '/reports/resellers?' + this.filtersQuery
            axios
                .get(url)
                .then(response => {
                    this.data = response.data.data
                    this.setFilters(response.data.meta.filters)
                    this.loading = false
                })
                .catch(error => {
                    this.$bus.$emit('notify', 'error', 'Ocorreu um erro.')
                    this.loading = false
                    return error
                })
        },

        async setFilters(filters) {
            this.$bus.$emit('filters', {
                resource: this.filterKey,
                allowed: filters.allowed,
            })
            this.hasFilters = true
        },
    },

    mounted() {
        this.fetchData()
    },
}
</script>

<style></style>
